module.exports = __webpack_public_path__ + "media/images/index/care_02_full-e52d1a81ae868575b865b8c358a8b1a3.jpg";